import styled from "styled-components/macro";

import { FnrPopover } from "UI/FnrPopover2";

export default function ButtonTooltip({
  show,
  buttonRef,
  content,
  offsetLeft = 0,
}) {
  return (
    <FnrPopover show={show} buttonRef={buttonRef} offsetLeft={offsetLeft}>
      <Content>{content}</Content>
    </FnrPopover>
  );
}

const Content = styled.div`
  text-align: center;
`;
